import { combineReducers, configureStore } from "@reduxjs/toolkit";
import mapSlice from "../features/projects/slice/MapSlice";
import projectSlice from "../features/projects/slice/ProjectSlice";
import promotedProjectSlice from "../features/projects/slice/PromotedProjectSlice";
import smsCampaign from "../features/smsCampaign/smsCampaignSlice/SmsCampaignSlice";
import storeSlice from "../features/store/silce/StoreSlice";
import activitySlice from "./ActivitySlice";
import customerDataSlice from "./CustomerDataSlice";
import projectDetailSlice from "./ProjectDetailSlice";
import salesSlice from "./SalesSlice";
import sharedSlice from "./SharedSlice";

const reducers = combineReducers({
    projects: projectSlice,
    promoted: promotedProjectSlice,
    shared: sharedSlice,
    map: mapSlice,
    projectDetail: projectDetailSlice,
    salesState: salesSlice,
    activityState: activitySlice,
    smsCampaign: smsCampaign,
    storeSlice: storeSlice,
    customerDataSlice: customerDataSlice,
});

export const store = configureStore({
    reducer: reducers,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
